import { render, staticRenderFns } from "./CmgRewards.vue?vue&type=template&id=39ee8cad&scoped=true&lang=pug&"
import script from "./cmg-rewards.ts?vue&type=script&lang=ts&"
export * from "./cmg-rewards.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewards.vue?vue&type=style&index=0&id=39ee8cad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ee8cad",
  null
  
)

export default component.exports